export const StateList = [ 
    "Andaman and Nicobar Islands", 
    "Andhra Pradesh", 
    "Arunachal Pradesh", 
    "Assam", 
    "Bihar", 
    "Chandigarh", 
    "Chhattisgarh", 
    "Dadra and Nagar Haveli", 
    "Daman and Diu", 
    "Delhi", 
    "Goa", 
    "Gujarat", 
    "Haryana", 
    "Himachal Pradesh", 
    "Jammu and Kashmir", 
    "Jharkhand", 
    "Karnataka", 
    "Kerala", 
    "Lakshadweep", 
    "Madhya Pradesh", 
    "Maharashtra", 
    "Manipur", 
    "Meghalaya", 
    "Mizoram", 
    "Nagaland", 
    "Odisha", 
    "Puducherry", 
    "Punjab", 
    "Rajasthan", 
    "Sikkim", 
    "Tamil Nadu", 
    "Telangana", 
    "Tripura", 
    "Uttar Pradesh", 
    "Uttarakhand", 
    "West Bengal"
]
